import {makeThemeProps} from "@themes/boost/props/utils";

export default (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getAppliedFiltersListProps(theme);
};
